/** Logs only in development (CRA inlines `NODE_ENV` at build time). */
export function devLog(...args) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}
